import { check } from 'src/modules/features/setting/modals';
import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import {
  CompanyService,
  OrganizationService,
  RoleService,
} from '../../services';
import { ApplicationService } from 'src/modules/features/setting/services';
interface ICompanyNewModalContext {
  data?: any;
  title?: string;
  isEdit?: boolean;
}
@Component({
  selector: 'app-company-mda-modal',
  templateUrl: './company-mda-modal.html',
  styleUrls: ['./company-mda-modal.scss'],
})
export class CompanyMdaModalComponent implements OnInit, OnDestroy {
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean = false;
  applications: Array<any> = [];

  companyForm: FormGroup;
  company;
  bizProvider: Array<any> = [];
  companyType: Array<any> = [];
  ownershipType: Array<any> = [];
  optionError: boolean;
  optionLoading: boolean;
  collapseForeign: boolean;
  collapse: boolean;
  optionFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'ownership_type',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'actual_company_type',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'foreign_company_providers',
      },
    ],
  };
  ownershipT;
  companyT;
  states;
  countries;
  organizationId;

  selectedCountry = {
    countryCode: 'NG',
    countryName: 'Nigeria',
    unRegion: 'Africa',
    unSubregion: 'Western Africa',
  };
  roles = [
    {
      id: 63703,
      roleId: 'CONTRACTOR_ADMIN',
      roleName: 'MDA Admin',
      roleDescription: 'Company Admin',
      dateCreated: '2018-03-05T00:00:00.000+0000',
      dateModified: '2022-09-27T09:01:54.205+0000',
      modifiedBy:
        '{"appUserId":"ncc-admin","username":"ncc-admin","name":"NCC ADMIN  Super","organizationId":"ncc","organizationName":"Nigerian Communications Commission "}',
      createdBy: '{"appUserId": "System"}',
      organizationId: null,
      organizationTypeId: 'contractor',
    },
  ];
  filter: AppFilter = new AppFilter();
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'applicationName',
        op: 'cn',
        data: '',
      },
    ],
  };
  isDisabled: boolean = true;
  companyEmail: boolean = false;
  emailInvitation: boolean = false;
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<ICompanyNewModalContext, void, void>,
    private companySvc: CompanyService,
    private organizationSvc: OrganizationService,
    private roleSvc: RoleService,
    private applicationSvc: ApplicationService
  ) {
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 100 });
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.organizationId = window.localStorage.getItem('organizationId');
    this.companyForm = fb.group({
      companyName: ['', [Validators.required]],
      headOfficeAddressStreet: ['', [Validators.required]],
      headOfficeAddressCity: ['', [Validators.required]],
      headOfficeAddressZip: [''],
      companyContactAlternativeEmail: [''],
      phoneNumber: ['', [Validators.required]],
      companyContactEmail: ['', [Validators.required]],
      appUserEmail: ['', [Validators.required]],
      headOfficeAddressState: ['', [Validators.required]],
      roleId: ['CONTRACTOR_ADMIN'],
      countryOfRegistration: ['', [Validators.required]],
      applicationId: ['', [Validators.required]],
    });
    this.getCountry();
    this.getStates();
    this.getApplications(1);
    // this.getRole();
    if (this.modal.context.isEdit) {
      //   this.company = modal.context.data.company;
      //   this.companyForm.patchValue(modal.context.data.company);
      //   this.companyForm
      //     .get('companyTypeId')
      //     .patchValue(modal.context.data.companyTypeId.optionId);
      //   this.companyForm
      //     .get('ownershipType')
      //     .patchValue(modal.context.data.ownershipType.optionId);
      //   this.companyT = modal.context.data.company['companyType'];
      //   this.ownershipT = modal.context.data.company['companyOwnershipType'];
    }
    // console.log(this.companyForm.value);
    // console.log(this.companyT);
    // this.getOptionTypes();
  }

  toggleCollapse(val) {
    if (
      val.optionId === 'niegria_owned' ||
      val.optionId === 'niegria_company_owned_by_foreign_company'
    ) {
      this.collapse = false;
      this.collapseForeign = true;
      console.log(val);
    } else {
      this.collapse = true;
      this.collapseForeign = false;
      console.log(val);
    }
  }
  toggleCollapsex(val) {
    if (val.optionId === 'business_name_actual') {
      console.log('clear validations');

      this.companyForm.controls['unverifiedTin'].clearValidators();
      this.companyForm.controls['companyName'].setValidators([
        Validators.required,
      ]);
      this.companyForm.updateValueAndValidity();
    } else {
      // this.isCountryName = false;
      // this.companyForm.get('unverifiedTin').validator = <any>Validators.compose([Validators.required]);
      this.companyForm.controls['companyName'].clearValidators();
      this.companyForm.controls['unverifiedTin'].setValidators([
        Validators.required,
      ]);
      this.companyForm.updateValueAndValidity();
    }
  }
  getRole() {
    let rolesParams = new AppFilter({ sidx: 'roleName', rows: 3000 });
    this.roleSvc
      .getRoles({ organizationId: this.organizationId, params: rolesParams })
      .subscribe(
        (res: any[]) => {
          // this.roles = res['rows'];
        },
        (error) => {
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  getOptionTypes() {
    this.optionError = false;
    this.optionLoading = true;
    this.companySvc
      .getOptions({ filter: JSON.stringify(this.optionFilter) })
      .pipe(
        takeUntil(this.unsubscribe$),
        map((res: any) => res.rows),
        map((res: any) => {
          let options = {
            ownershipType: [],
            companyType: [],
            errorOption: [],
            providerType: [],
          };
          res.forEach((option) => {
            // console.log(option)
            switch (option.optionType.optionTypeId) {
              case 'ownership_type':
                options.ownershipType.push(option);
                break;
              case 'actual_company_type':
                options.companyType.push(option);
                break;
              case 'foreign_company_providers':
                options.providerType.push(option);
                break;
              default:
                options.errorOption.push(option);
            }
          });
          return options;
        })
      )
      .subscribe(
        (res) => {
          // console.log(res);
          this.optionLoading = false;
          this.companyType = res.companyType;
          this.ownershipType = res.ownershipType;
          this.bizProvider = res.providerType;
        },
        (error) => {
          // console.log(error)
          this.optionError = true;
          this.optionLoading = false;
        }
      );
  }
  isFieldValid(field: string) {
    return (
      (!this.companyForm.get(field).valid &&
        this.companyForm.get(field).touched) ||
      (this.companyForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
  submit() {
    if (this.companyForm.valid) {
      this.modal.context.isEdit == true ? this.update() : this.saveMda();
    } else {
      this.error = 'Fill all required details';
    }
  }
  update() {
    this.success = null;
    this.error = null;
    this.pending = true;
    const self = this;
    let data = this.companyForm.value;
    data['companyType'] = { optionId: data['companyTypeId'] };
    data['ownershipType'] = { optionId: data['ownershipType'] };
    this.companySvc
      .updateOldCompany({
        companyId: this.company.oldCustomerId,
        body: { ...this.company, ...data },
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Company edited  successfully';
          setTimeout(() => {
            this.modal.approve(null);
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  newOrganizationId;
  saveMda() {
    this.checkEmailExist(this.companyForm.value.appUserEmail);
  }
  save() {
    this.pending = true;
    this.success = null;
    this.error = null;
    let data = this.companyForm.value;
    data.countryOfRegistration = {
      countryCode: 'NG',
      countryName: 'Nigeria',
      unRegion: 'Africa',
      unSubregion: 'Western Africa',
    };
    // delete data.applicationId;
    this.companySvc
      .addEntity({
        body: data,
        organizationTypeId: 'mda',
        restrictedApplicationId: this.companyForm.value.applicationId,
      })
      .subscribe(
        (res) => {
          this.newOrganizationId = res;
          this.saveUser(res);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  checkEmailExist(data) {
    this.pending = true;
    this.companySvc
      .checkEmail({
        email: data,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          res.status
            ? (this.emailInvitation = false)
            : (this.emailInvitation = true);
          this.checkCompaniesEmailExist(
            this.companyForm.value.companyContactEmail
          );
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  checkCompaniesEmailExist(data) {
    this.pending = true;
    this.companySvc
      .checkCompanyEmail({
        email: data,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          res.status ? (this.companyEmail = false) : (this.companyEmail = true);
          if (this.companyEmail && this.emailInvitation) {
            this.error =
              'The company email and the email provided for the invitation link have already been used.';
          } else if (this.companyEmail && !this.emailInvitation) {
            this.error = 'The company email have already been used.';
          } else if (!this.companyEmail && this.emailInvitation) {
            this.error =
              'The email provided for the invitation link have already been used.';
          }
          if (!this.companyEmail && !this.emailInvitation) {
            this.save();
          }
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  saveUser(data) {
    this.pending = true;
    // let body = {
    //   appUserEmail: this.companyForm.value.appUserEmail,
    //   userRole: this.companyForm.value.roleId,
    // };
    let body = { ids: [this.companyForm.value.appUserEmail] };
    this.companySvc
      .inviteNewUser({
        organizationId: data.organizationId,
        body: body,
        roleId: this.companyForm.value.roleId,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'MDA Entity created  successfully';
          setTimeout(() => {
            this.modal.approve(null);
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  saveExistingUser(data) {
    this.pending = true;
    let body = {
      appUserId: data,
      userRole: this.companyForm.value.roleId,
    };

    this.companySvc
      .inviteExistingUser({
        organizationId: this.newOrganizationId,
        body: body,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'MDA Company created  successfully';
          setTimeout(() => {
            this.modal.approve(null);
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  getCountry() {
    this.organizationSvc
      .getCountries({ organizationId: this.organizationId })
      .subscribe((res) => {
        this.countries = res['rows'];
      });
  }
  getApplications(page) {
    this.filter.page = page;
    this.pending = true;
    this.applicationSvc.getApplications({ params: this.filter }).subscribe(
      (res: any) => {
        this.pending = false;
        this.applications = res['rows'];
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
      }
    );
  }
  getStates() {
    this.organizationSvc.getStates({ filter: '' }).subscribe((res) => {
      this.states = res['rows'];
    });
  }
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
}

export class CompanyMdaModal extends ComponentModalConfig<
  ICompanyNewModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    isEdit: boolean,
    size: ModalSize = ModalSize.Mini
  ) {
    super(CompanyMdaModalComponent, { title, data, isEdit });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = ModalSize.Mini;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
